import { InjectionToken } from '@angular/core';

export const PROGRAM_BASE_URL = new InjectionToken<string>('PROGRAM_BASE_URL');
